import menu from './util/menu.js'
import arrayUtil from './util/ArrayUtil.js'
import treeUtil from './util/TreeUtil'

function objectEmpty(obj){
  for(let x in obj){
    obj[x] = ''
  }
}

export default{
  menu,arrayUtil,objectEmpty,treeUtil
}
